export const extractVideoId = url => {
  const result = /vimeo\.com\/external\/(\d+)/.exec(url);

  if (result && result[1]) {
    return result[1];
  }

  return null;
};
